import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core'

/**
 * Directive to act on HTML nodes, intercept anchor tags and add target=“_blank” to each of them
 */
@Directive({
  selector: '[appExternalLinks]',
})
export class ExternalLinkDirective implements AfterViewInit {
  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2,
  ) {}

  ngAfterViewInit() {
    this.modifyLinks()
  }

  private modifyLinks() {
    const element: HTMLElement = this.el.nativeElement

    /**
     * Finds all links (anchor tags) within the current element
     */
    const links = element.querySelectorAll('a')

    /**
     * Adds target=“_blank” to each anchor tag
     */
    links.forEach((link) => {
      this.renderer.setAttribute(link, 'target', '_blank')
    })
  }
}
